import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import icons from 'config/icons';

import styles from './loadingSpinner.css';

const LoadingSpinner = () => (
  <div className={styles.wrapper}>
    <img
      alt="Loading"
      className={styles.loadingSpinner}
      src={icons.loadingSpinner}
      height="30"
      width="30"
    />
  </div>
);

export default withStyles(styles)(LoadingSpinner);
